import { SORTING_TYPES as sort, PRODUCT_FIELDS as fields } from "../../utils/js/constants";

const getAttributes = (sortBy) => {
    switch (sortBy) {
        case sort.NOME: {
            return {
                key: 'nome',
                ascending: true,
                type: 'string',
            }
        }
        case sort.ESTOQUE_BAIXO: {
            return {
                key: 'estoque_atual',
                ascending: true,
                type: 'number',
            }
        }
        case sort.ESTOQUE_ALTO: {
            return {
                key: 'estoque_atual',
                ascending: false,
                type: 'number',
            }
        }
        case sort.PRECO_BAIXO: {
            return {
                key: 'preco',
                ascending: true,
                type: 'number',
            }
        }
        case sort.PRECO_ALTO: {
            return {
                key: 'preco',
                ascending: false,
                type: 'number',
            }
        }
        default:
            return false;
    }
}

const sortProductsByKey = (products, params) => {
    let sortedProducts = [];

    if (params.type === 'string') {
        params.ascending ? sortedProducts = products.sort((a, b) => (a[params.key] > b[params.key] ? 1 : -1))
            : sortedProducts = products.sort((a, b) => (a[params.key] < b[params.key] ? 1 : -1))
    }

    if (params.type === 'number') {
        params.ascending ? sortedProducts = products.sort((a, b) => (a[params.key] - b[params.key]))
            : sortedProducts = products.sort((a, b) => (b[params.key] - a[params.key]))
    }

    return sortedProducts;
}

const getSegmentSet = (products) => {
    let segmentSet = new Set();

    products.forEach((product) => {
        let segments = product.segmento ?? ['OUTROS'];

        segments.forEach((segment) => {
            segmentSet.add(segment);
        });
    })

    return segmentSet;
}

const populateListOfSegment = (products, segment) => {
    let listOfSegment = [];

    products.forEach((product) => {
        let segmentProduct = product.segmento ?? ['OUTROS'];

        if (segmentProduct[0] === segment) {
            listOfSegment.push(product)
        }
    });

    return listOfSegment;
}

const groupBySegment = (products) => {
    let segmentSet = getSegmentSet(products);
    let groupedProducts = [];

    segmentSet.forEach((segment) => {
        let listOfSegment = populateListOfSegment(products, segment);
        groupedProducts[segment] = listOfSegment;
    });

    return groupedProducts;
}

const sortAndFilterProducts = (products, sortBy, isSearchBySegment) => {
    const params = getAttributes(sortBy);

    let sortedProducts = sortProductsByKey(products, params);

    if (isSearchBySegment) {
        sortedProducts = groupBySegment(sortedProducts);
    }

    return sortedProducts;
}

const filterProducts = (products, fieldName, inputSearch) => {
    return products.filter((product) => {
        let value = product[fieldName];

        return value?.toUpperCase().includes(inputSearch?.toUpperCase());
    });
}

let dynamicSearch = (products, inputSearch) => {
    let filteredList = filterProducts(products, fields.CODE_FIELD, inputSearch);

    if (filteredList?.length === 0) {
        filteredList = filterProducts(products, fields.NAME_FIELD, inputSearch);
    }

    return filteredList;
}

export { sortAndFilterProducts, dynamicSearch };
